export class TicketDocumentInput {
    public documentFile: string = '';
    public documentFileName: string = '';
}
